import { db } from "./db";

async function sha256(value) {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);

  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

function normalizeUsername(username) {
  return String(username || "")
    .trim()
    .toLowerCase();
}

export async function saveOfflineAuthSession({ username, password }) {
  const normalizedUsername = normalizeUsername(username);

  if (!normalizedUsername || !password) return;

  const passwordHash = await sha256(`${normalizedUsername}:${password}`);

  await db.offline_auth.put({
    username: normalizedUsername,
    passwordHash,
    savedAt: new Date().toISOString(),

    user: sessionStorage.getItem("user") || normalizedUsername,
    authority: sessionStorage.getItem("authority") || "",
    perfil: sessionStorage.getItem("perfil") || "",
    proveedor: sessionStorage.getItem("proveedor") || "",
    clientId: sessionStorage.getItem("clientId") || "",
  });
}

export async function validateOfflineLogin(username, password) {
  const normalizedUsername = normalizeUsername(username);

  if (!normalizedUsername || !password) {
    return {
      ok: false,
      message: "Debe ingresar usuario y contraseña.",
    };
  }

  const savedSession = await db.offline_auth.get(normalizedUsername);

  if (!savedSession) {
    return {
      ok: false,
      message:
        "Este usuario no tiene sesión offline guardada. Debe iniciar sesión online al menos una vez.",
    };
  }

  const passwordHash = await sha256(`${normalizedUsername}:${password}`);

  if (passwordHash !== savedSession.passwordHash) {
    return {
      ok: false,
      message: "Credenciales offline incorrectas.",
    };
  }

  return {
    ok: true,
    session: savedSession,
  };
}

export function restoreOfflineSessionToSessionStorage(
  session,
  username,
  password,
) {
  sessionStorage.setItem("isLoggedIn", "true");
  sessionStorage.setItem("authUsername", username);
  sessionStorage.setItem("authPassword", password);

  sessionStorage.setItem("user", session.user || username);
  sessionStorage.setItem("authority", session.authority || "");
  sessionStorage.setItem("perfil", session.perfil || "");
  sessionStorage.setItem("proveedor", session.proveedor || "");
  sessionStorage.setItem("clientId", session.clientId || "");
}
